module.exports = __webpack_public_path__ + "static/media/logoLanding.dc25bf71.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logoLanding.png
// module id = 779
// module chunks = 0